export interface IOrderGISRequest {

    CDKey: string;
    ProductID: number;
    CCID: number;

}

export class OrderGISRequest implements IOrderGISRequest {

    CDKey: string;
    ProductID: number;
    CCID: number;

}